var _defs, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.022h-.358c.15-.391.464-.7.858-.845v.345a.5.5 0 01-.5.5zm-13.5-.5v-.345c.394.145.708.454.858.845H1.5a.5.5 0 01-.5-.5zm.5-7.5h.366A1.461 1.461 0 011 3.888v-.366a.5.5 0 01.5-.5zM6 1.642C6 1.287 6.288 1 6.641 1H9.36c.353 0 .641.288.641.641v.38H6v-.38zm9 1.88v.366a1.461 1.461 0 01-.866-.866h.366a.5.5 0 01.5.5zm-1.9 7.5H2.9A2.464 2.464 0 001 9.138V4.927a2.464 2.464 0 001.905-1.905h10.19A2.464 2.464 0 0015 4.927v4.211a2.464 2.464 0 00-1.9 1.884zm1.4-9H11v-.38C11 .735 10.264 0 9.359 0H6.64C5.736 0 5 .736 5 1.641v.38H1.5c-.827 0-1.5.674-1.5 1.5v7c0 .828.673 1.5 1.5 1.5h.818c.044.014.09.023.139.023a.493.493 0 00.138-.022h10.81c.044.013.09.022.139.022a.492.492 0 00.138-.022h.818c.827 0 1.5-.673 1.5-1.5v-7c0-.827-.673-1.5-1.5-1.5z",
    id: "briefcase_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "briefcase_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#briefcase_svg__a"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: props.color,
    xlinkHref: "#briefcase_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#briefcase_svg__b)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0-2h16v15.964H0z"
  })))));
}
export default SvgBriefcase;